const MIN_CHARACTERS = 8

const DEFAULT_RULES = [
  "min-characters",
  "at-least-one-number",
  "upper-and-lower",
  "at-least-one-special-character",
]

export const validatePassword = (password, rules = DEFAULT_RULES) => {
  let passedRules = []

  if (rules.includes("min-characters")) {
    if (minCharacters(password)) passedRules.push("min-characters")
  }
  if (rules.includes("at-least-one-number")) {
    if (atLeastOneNumber(password)) passedRules.push("at-least-one-number")
  }
  if (rules.includes("upper-and-lower")) {
    if (upperAndLower(password)) passedRules.push("upper-and-lower")
  }
  if (rules.includes("at-least-one-special-character")) {
    if (atLeastOnespecialCharacter(password))
      passedRules.push("at-least-one-special-character")
  }

  let status = passedRules.length === rules.length

  return { status, passedRules }
}

export const minCharacters = (password) => {
  return password.length >= MIN_CHARACTERS
}

export const atLeastOneNumber = (password) => {
  return password.match(/[0-9]/g) != null
}

export const atLeastOnespecialCharacter = (password) => {
  return password.match(/\W|_/g) != null
}

export const upperAndLower = (password) => {
  return password.match(/[a-z]/) != null && password.match(/[A-Z]/) != null
}



export const samePasswordInput = (password, password_confirmation) => {
  return password === password_confirmation;
}
